import ListPostComponent from '@components/list-post';
import * as React from 'react';

export interface IListPostPageProps {}

export default function ListPostPage(props: IListPostPageProps) {
  return <ListPostComponent />;
}
